import './people.scss';
import * as React from 'react';
import FullScreenSection from '../../components/layout/fullScreenSection';
import PageHero from '../../components/layout/pageHero';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { View } from '../../components/layout/view';
import { LazyCosmosImage } from '../../components/media/cosmosImage';
import { StaffMembersBusiness, StaffMembersDesign, StaffMembersDevelopment } from '../../components/people/staffMembers';
import { StaffMembersManagement } from '../../components/people/staffMembersManagement';
import { EmployeeQuotes } from '../../components/quotes/employeeQuotes';
import usePersonnelPage from '../../hooks/staticQueries/staff/usePersonnelPage';
import { ImageUtils } from '../../utils/image';
export const PeoplePage = () => {
    const { page } = usePersonnelPage();
    return (<View className="personnel" title="People">
      <PageHero>
        <FullScreenSection darkenBg={false} mini background={<LazyCosmosImage ticket={page.hero_image[0].ticket} alt="personnel" size={ImageUtils.imageSizes.large}/>}/>
      </PageHero>

      <SectionTitle title={page.page_title_section.title} markdown={page.page_title_section.description} imageTicket={page.page_title_section.icon[0].ticket}/>

      <div className="personnel-inner">
        <StaffMembersManagement />

        <h3>Business and Operations</h3>
        <StaffMembersBusiness />

        <h3>Design</h3>
        <StaffMembersDesign />

        <h3>Development</h3>
        <StaffMembersDevelopment />
      </div>

      <EmployeeQuotes />

      <Footer />

      <BackToTop />
    </View>);
};
export default PeoplePage;
